import React from 'react';
import cx from 'classnames';
import CheckboxSvg from 'images/svg/checkmark.svg';
import './RequestQuoteAnswer.scss';

const RequestQuoteAnswer = ({
  title,
  icon,
  multiselect,
  iconPaths,
  currentStepAnswers,
  text,
  onClick,
  onChange,
  nextStep,
}) =>
  multiselect ? (
    <label
      htmlFor={title}
      className={cx({
        'request-quote-answer': true,
        'request-quote-answer--selected': currentStepAnswers && currentStepAnswers.includes(title),
        'request-quote-answer--multiselect': multiselect,
      })}
    >
      <div
        className={cx({
          'request-quote-answer__checkbox-wrapper': true,
          'request-quote-answer__checkbox-wrapper--selected':
            currentStepAnswers && currentStepAnswers.includes(title),
          'request-quote-answer__checkbox-wrapper--multiselect': multiselect,
        })}
      >
        <CheckboxSvg className="request-quote-answer__img" src="images/svg/checkbox.svg" alt="" />
      </div>
      <h6 className="h6 h6--bold h6--no-margin">{title}</h6>
      <input id={title} type="checkbox" name={nextStep} value={title} onClick={onChange} />
    </label>
  ) : (
    <label htmlFor={title} className={cx({ 'request-quote-answer': true })}>
      {icon ? (
        <div className="request-quote-answer__img-wrapper">
          <img className="request-quote-answer__img" src={iconPaths[icon].publicURL} alt="" />
        </div>
      ) : (
        <div className="request-quote-answer__img-wrapper">
          <p className="body-1 body-1--no-margin body-1--white body-1--bold">{text}</p>
        </div>
      )}
      <h6 className="h6 h6--bold h6--no-margin">{title}</h6>
      <input id={title} type="radio" name={nextStep} value={title} onClick={onClick} />
    </label>
  );

export default RequestQuoteAnswer;
